module.exports = __webpack_public_path__ + "img/bess_feeder_cap.2ed06d25.svg";